import fetch from '@/plugins/fetch'
import jsCookie from 'js-cookie'
import utils from '@/plugins/utils'
/**
 * 临时
 * 服务待产包
 * CMS配置
 */
export async function getSpuIdsFromCMS() {
  const url = '//cms.cekid.com/publish/999/package_of_child_birth_service.json'
  try {
    const res = await fetch(url)
    const j = await res.json()
    // console.log(j)
    if (+j.code === 0) {
      return j.data
    }
    return {}
  } catch (error) {
    throw error
  }
}

export async function getPregantAuthStatus() {
  const { uid, skey } = await utils.ensureLogin()

  const url = '//user.cekid.com/user/GetPregantAuthStatus'
  try {
    const res = await fetch(`${url}?uid=${uid}&skey=${skey}`, {
      credentials: 'include'
    })
    const j = await res.json()
    // console.log(j)
    if (+j.errno === 0) {
      return j.data
    }
    return {}
  } catch (error) {
    throw error
  }
}
